import React, { useContext } from "react";
import { ConfirmButton, CueText, MainContainer } from "./styles";
import { useRouter } from "next/router";
import { Context } from "@components/useContext/context";
import { connect, useDispatch, useSelector } from "react-redux";
import { getWidgetSpecificProps } from "@utils/index";
import { updateNormalisedConfig } from "@store/slices/config";
import { FormatCTAtext } from "@components/mmvNotFoundModal";

const mapStateToProps = function (state: any, ownProps: any) {
  return getWidgetSpecificProps(
    state.configuration?.normalisedConfig,
    ownProps.id
  );
};

const Button = (props: any) => {
  const dispatch = useDispatch();
  const { isDesktop } = useContext(Context);
  const {
    actions,
    cueText,
    label,
    styles,
    children,
    wrapperStyles,
    dWrapperStyles,
    is_visible,
    checkDisabled
  } = props;
  const router = useRouter();
  const { proposal_ekey, current_node } = router.query;

  const { globalPayloadData, normalisedConfig } = useSelector(
    ({ globalState, configuration }: any) => {
      return {
        normalisedConfig: configuration?.normalisedConfig,
        globalPayloadData: globalState?.payloadData
      };
    }
  );
  
  const { conditional_call, on_click, validate_call_func } = actions || [];

  const selectedDate = globalPayloadData?.selectedDate;
  const selectedSlot = globalPayloadData?.selectedSlot;
  const isMissingSelection = !selectedDate || !selectedSlot;
  
  const isDisabled = checkDisabled ? isMissingSelection : false;

  const handleProceed = async () => {
    let payload = {
      ...on_click?.[0]?.args,
      requestBody: {
        current_node: current_node,
        expected_node: "",
        ...on_click?.[0]?.args?.requestBody
      },
      data: {
        proposal_ekey: proposal_ekey,
        ...globalPayloadData,
        ...on_click?.[0]?.args?.data
      }
    };

    if (conditional_call?.length > 0) {
      if (
        conditional_call?.[0] &&
        typeof conditional_call[0].funCall === "function"
      ) {
        conditional_call[0].funCall({
          ...(conditional_call[0].args || {})
        });
      }
    } else if (validate_call_func?.length > 0) {
      if (
        validate_call_func?.[0] &&
        typeof validate_call_func[0].funCall === "function"
      ) {
        const args = validate_call_func[0].args;
        const { required_fields } = args;
        const getData = await validate_call_func[0].funCall({
          requiredFields: required_fields,
          normalisedConfig,
          globalPayloadData
        });

        const { updatedNormalisedConfig, isError } = getData || {};

        dispatch(
          updateNormalisedConfig({
            normalisedConfig: updatedNormalisedConfig
          })
        );

        if (!isError) {
          if (validate_call_func?.length > 1) {
            validate_call_func?.slice(1).forEach((eachFunc: any) => {
              typeof eachFunc.funCall === "function" &&
                eachFunc.funCall(eachFunc.args);
            });
          }
        }
      }
    } else {
      if (on_click?.[0] && typeof on_click[0].funCall === "function") {
        on_click?.forEach((eachFunc: any) => {
          if (eachFunc?.funCall?.name === "GoToHomePage") {
            window.location.href =
              process.env.HOST_URL || "https://www.ackodev.com/t/car";
          }
          payload = {
            ...payload,
            ...eachFunc.args
          };
          eachFunc.funCall({ shouldRedirect: true, ...payload });
        });
      }
    }
  };

  return is_visible?(
    <MainContainer
      wrapperStyles={wrapperStyles}
      dWrapperStyles={dWrapperStyles}
    >
      <ConfirmButton
        padding="13px 32px"
        width={isDesktop ? "320px" : "100%"}
        onClick={isDisabled ? undefined : handleProceed}
        disabled={isDisabled}
        styles={styles}
      >
        <FormatCTAtext>{label}</FormatCTAtext>
      </ConfirmButton>
      {cueText ? <CueText>{cueText}</CueText> : null}
      {children}
    </MainContainer>
  ):null;
};

export default connect(mapStateToProps)(Button);
